import * as zod from 'zod';

import { Expression } from '../../types';

export default zod.object({
  variableID: zod.string(),
  newValue: Expression,

  // NOTE (MW, 2025/03/31)  These fields shouldn't actually be used. Instead, get them from the variable state when playing. Ensures that name, etc. is up-to-date at runtime.
  variableName: zod.string(),
  isGlobal: zod.boolean().optional().default(false),
});
